import { FolderOpen } from 'lucide-react'
import { Project, Game } from './types'

interface ProjectInfoViewProps {
  projectId: string
  project: Project | undefined
  selectedGame: Game | null
}

export function ProjectInfoView({
  projectId,
  project,
  selectedGame,
}: ProjectInfoViewProps) {
  return (
    <div className="rounded-lg border border-[#1e212f] bg-[#0c0d13] p-5 space-y-4 font-sans text-xs">
      <h3 className="text-xs font-bold uppercase tracking-wider text-gray-100 flex items-center space-x-2">
        <FolderOpen className="h-4 w-4 text-[#38bdf8]" />
        <span>Workspace Parameters</span>
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="space-y-3">
          <div>
            <div className="text-[10px] text-muted-foreground uppercase">Project Identifier</div>
            <div className="font-mono text-xs text-gray-200 mt-0.5 select-all">{projectId}</div>
          </div>
          <div>
            <div className="text-[10px] text-muted-foreground uppercase">Logical Destination</div>
            <div className="font-mono text-xs text-[#38bdf8] mt-0.5">
              {project?.publisherSlug && project?.gameSlug
                ? `${project.publisherSlug}/${project.gameSlug}`
                : project?.gameSlug
                  ? `.../${project.gameSlug}`
                  : '...'
              }
            </div>
          </div>
          <div>
            <div className="text-[10px] text-muted-foreground uppercase">Publisher Owner</div>
            <div className="text-xs text-gray-200 mt-0.5 font-semibold">{project?.ownerName || 'Unknown'}</div>
          </div>
        </div>

        <div className="space-y-3">
          <div>
            <div className="text-[10px] text-muted-foreground uppercase">Last Active (Local machine log)</div>
            <div className="font-mono text-xs text-gray-200 mt-0.5">
              {project?.lastActive ? new Date(project.lastActive).toLocaleString() : 'N/A'}
            </div>
          </div>
          <div>
            <div className="text-[10px] text-muted-foreground uppercase">Last Catalog Publish Time</div>
            <div className="font-mono text-xs text-gray-200 mt-0.5">
              {project?.lastPublished ? new Date(project.lastPublished).toLocaleString() : 'Never published'}
            </div>
          </div>
          <div>
            <div className="text-[10px] text-muted-foreground uppercase">Versions in Catalog</div>
            <div className="font-mono text-xs text-gray-200 mt-0.5">{selectedGame?.versionCount || 0}</div>
          </div>
        </div>
      </div>
    </div>
  )
}
